import React from "react";

export const StorMiLogo = ({ className = "", onClick, dark = false }) => (
  <div
    className={`flex items-center select-none ${onClick ? "cursor-pointer" : ""} ${className}`}
    onClick={onClick}
    data-testid="stormi-logo"
  >
    <img
      src={`${process.env.PUBLIC_URL || ""}/stormi-logo.png`}
      alt="StorMi"
      className="h-8 w-auto"
      draggable="false"
    />
  </div>
);
